import type { ReactNode } from 'react';
import { ValueBadge } from './ValueBadge';

export type StatusTone = 'neutral' | 'info' | 'success' | 'warning' | 'danger';

export type StatusBadgeProps = {
  label: ReactNode;
  tone?: StatusTone;
};

export function StatusBadge({ label, tone = 'neutral' }: StatusBadgeProps) {
  return <ValueBadge label={label} tone={tone} />;
}
